import { content, width } from '../../common/const/componentSize';

export const searchBoxAndresultNumBox = {
	height: content.height,
	width: '550px',
};
export const searchBox = {
	height: '550px',
	width: '500px',
	borderRadius: '12px',
	top: content.top,
	left: '20px',
};

export const search = {
	titleHeight: '40px',
	titleMarginLeft: 1.5,
	height: '500px',
	width: `calc(${searchBox.width} * 0.95)`,
	halfWidth: `calc((${searchBox.width} * 0.95) / 2)`,
};

export const resultNumBox = {
	height: '250px',
	width: searchBox.width,
	top: '620px',
	left: searchBox.left,
};

export const resultNum = {
	width: '300px',
	lableWidth: '200px',
	marginTop: 3,
	marginLeft: 5,
};

export const tableBox = {
	height: `calc(${content.height} - 20px)`,
	width: `calc(${width} - ${searchBoxAndresultNumBox.width} - ${searchBox.left})`,
};

export const table = {
	height: `calc(${tableBox.height} - 50px)`,
};
